module.exports = __webpack_public_path__ + "fonts/iconfont.d2fa2faa.ttf";